import { ReactComponent as Cargo } from '@quick/assets/icons/lines/cargo.svg';
import { ReactComponent as carry } from '@quick/assets/icons/lines/carry.svg';
import { ReactComponent as delivery } from '@quick/assets/icons/lines/delivery.svg';
import { ReactComponent as Distribution } from '@quick/assets/icons/lines/distribution.svg';
import { ReactComponent as FLTruck } from '@quick/assets/icons/lines/FLTruck.svg';
import { ReactComponent as FLTruckPentagon } from '@quick/assets/icons/lines/FLTruckPentagon.svg';
import { ReactComponent as Global } from '@quick/assets/icons/lines/global.svg';
import { ReactComponent as Go } from '@quick/assets/icons/lines/go.svg';
import { ReactComponent as moto } from '@quick/assets/icons/lines/moto.svg';
import { ReactComponent as TruckFlorida } from '@quick/assets/icons/lines/TruckFlorida.svg';
import { ReactComponent as USTruck } from '@quick/assets/icons/lines/USTruck.svg';
import { ReactComponent as USTruckPentagon } from '@quick/assets/icons/lines/USTruckPentagon.svg';
import { ReactComponent as Warehouse } from '@quick/assets/icons/lines/Warehouse.svg';

const lineIcons = {
  global: Global,
  distribution: Distribution,
  lastMille: Go,
  cargo: Cargo,
  delivery,
  carry,
  moto,
  FLTruck,
  FLTruckPentagon,
  USTruck,
  USTruckPentagon,
  TruckFlorida,
  Warehouse,
} as const;

export const lineIconsNames = Object.keys(
  lineIcons
) as (keyof typeof lineIcons)[];
export { lineIcons };
